import { useGenericReducer } from "@hooks/state/useGenericReducer";
import GridHistoricoSolicitacao from "@components/Solicitacao/Shared/Sections/HistoricoSection/Grid";

function SolicitacaoHistoricoSection({ solicitacaoFields }) {
    const NomeForm = "Histórico:";
    const NumeroSolicitacao = solicitacaoFields?.numeroSolicitacao;
    const UnidadeGerencia = "Unidade/Gerência:";
    const NomeUnidadeGerencia = solicitacaoFields?.unidadeGerencia?.nome;
    const { setData } = useGenericReducer();
    
    return (
        <div className="row mt-4">
            <div className="col-12 col-md-12">
                <div className="block h-auto">
                    <div className="container-fluid">
                        <div className="row">

                            <div className="col-12 col-md-12 d-flex justify-content-between align-items-start">
                                {/* Lado Esquerdo */}
                                <div className='d-flex align-items-start'>
                                    <h2 className="mb-0">{NomeForm}</h2>
                                    <h3 className="mx-3">{NumeroSolicitacao}</h3>
                                </div>

                                {/* Lado Direito */}
                                <div className='d-flex align-items-end'>
                                    <h2 className='mb-0'>{UnidadeGerencia}</h2>
                                    <h3 className="mx-3">{NomeUnidadeGerencia}</h3>
                                </div>
                            </div>

                            <div className="row g-0">

                                <GridHistoricoSolicitacao
                                    setData={setData}
                                    idSolicitacao={solicitacaoFields?.id}
                                />

                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default SolicitacaoHistoricoSection;